interface V3IconRSSProps extends React.SVGProps<SVGSVGElement> {
}

export const V3IconRSS = ({ }: V3IconRSSProps) => <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.666 12.667a.667.667 0 1 0 1.334 0 .667.667 0 0 0-1.334 0ZM2.666 2.667a10.667 10.667 0 0 1 10.667 10.666M2.666 7.333a6 6 0 0 1 6 6" stroke="#ABB0BA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>